import styled from 'styled-components';
import { Input } from 'reactstrap';

export const ConfigTextarea = styled(Input)`
  font-family: 'Courier New';
`;
